<label
  class="pill-toggle"
  [ngClass]="size"
  [style.--active-color]="activeColor"
  [style.--inactive-color]="inactiveColor"
>
  <input
    type="checkbox"
    class="pill-toggle-input"
    [checked]="isChecked"
    (change)="toggle()"
  />
  <span class="pill-switch"></span>
</label>
